import normalizeJsonApi from '../../shared/utilities/jsonApiNormalizer';

import {
    MessageTemplate,
    MessageTemplateFromAPI,
    MessageTemplatesJSONAPIResponse,
    SerializedMessageTemplate,
} from './types';

const messageTemplateSerializer = (messageTemplate: MessageTemplateFromAPI): MessageTemplate => ({
    id: messageTemplate.id,
    ...messageTemplate.attributes,
});

export function serializeMessageTemplateFromAPI(
    json: MessageTemplatesJSONAPIResponse,
): SerializedMessageTemplate {
    const { messageTemplate: messageTemplates } = normalizeJsonApi<{
        messageTemplate: { [key: string]: MessageTemplateFromAPI };
    }>(json);
    return {
        messageTemplate: messageTemplates
            ? Object.fromEntries(
                  Object.entries(messageTemplates).map(([key, value]) => [
                      key,
                      messageTemplateSerializer(value),
                  ]),
              )
            : {},
    };
}
